const FileType = {
  IMAGE: 'image',
  URL: 'url',
  VIDEO: 'video',
};

export const FileTypeTranslate = {
  [FileType.IMAGE]: (t) => t('image'),
  [FileType.URL]: (t) => t('link'),
  [FileType.VIDEO]: (t) => t('video'),
};
